export const pricingModelRequiresDailyBilling = (pricingModel) =>
  pricingModel === "dual_pricing" || pricingModel === "surcharge";

const getDualPricingDefaults = (pricingDefaults = {}) => {
  return {
    dual_pricing_rate:
      pricingDefaults?.dual_pricing?.dual_pricing_rate?.default ?? "",
    dual_pricing_per_transaction:
      pricingDefaults?.dual_pricing?.dual_pricing_per_transaction?.default ??
      "",
    dual_pricing_monthly_fee:
      pricingDefaults?.dual_pricing?.dual_pricing_monthly_fee?.default ?? "",
    dual_pricing_pin_debit_network_fee: "no",
    dual_pricing_pin_debit_rate:
      pricingDefaults?.dual_pricing?.dual_pricing_pin_debit_rate?.default ?? "",
    dual_pricing_pin_debit_per_transaction:
      pricingDefaults?.dual_pricing?.dual_pricing_pin_debit_per_transaction
        ?.default ?? "",
  };
};

const getSurchargeDefaults = (pricingDefaults = {}) => {
  return {
    surcharge_rate: pricingDefaults?.surcharge?.surcharge_rate?.default ?? "",
    surcharge_per_transaction:
      pricingDefaults?.surcharge?.surcharge_per_transaction?.default ?? "",
    surcharge_monthly_fee:
      pricingDefaults?.surcharge?.surcharge_monthly_fee?.default ?? "",
    surcharge_pin_debit_network_fee:
      pricingDefaults?.surcharge?.surcharge_pin_debit_network_fee?.default ??
      "yes",
    surcharge_pin_debit_rate:
      pricingDefaults?.surcharge?.surcharge_pin_debit_rate?.default ?? "",
    surcharge_pin_debit_per_transaction:
      pricingDefaults?.surcharge?.surcharge_pin_debit_per_transaction
        ?.default ?? "",
    surcharge_qual_debit_rate:
      pricingDefaults?.surcharge?.surcharge_qual_debit_rate?.default ?? "",
    surcharge_qual_debit_per_transaction:
      pricingDefaults?.surcharge?.surcharge_qual_debit_per_transaction
        ?.default ?? "",
    surcharge_mid_qual_debit_rate:
      pricingDefaults?.surcharge?.surcharge_mid_qual_debit_rate?.default ?? "",
    surcharge_mid_qual_debit_per_transaction:
      pricingDefaults?.surcharge?.surcharge_mid_qual_debit_per_transaction
        ?.default ?? "",
    surcharge_non_qual_debit_rate:
      pricingDefaults?.surcharge?.surcharge_non_qual_debit_rate?.default ?? "",
    surcharge_non_qual_debit_per_transaction:
      pricingDefaults?.surcharge?.surcharge_non_qual_debit_per_transaction
        ?.default,
    surcharge_signature_debit_rate:
      pricingDefaults?.surcharge?.surcharge_signature_debit_rate?.default ?? "",
    surcharge_signature_debit_per_transaction:
      pricingDefaults?.surcharge?.surcharge_signature_debit_per_transaction
        ?.default ?? "",
  };
};

const getFlatRateDefaults = (pricingDefaults = {}) => {
  return {
    flat_rate: pricingDefaults?.flat_rate?.flat_rate?.default ?? "",
    flat_rate_transaction:
      pricingDefaults?.flat_rate?.flat_rate_transaction?.default ?? "",
    flat_rate_amex: pricingDefaults?.flat_rate?.flat_rate_amex?.default ?? "",
    flat_rate_amex_transaction:
      pricingDefaults?.flat_rate?.flat_rate_amex_transaction?.default ?? "",
    flat_rate_pin_debit_network_fee: "yes",
    flat_rate_pin_debit_rate:
      pricingDefaults?.flat_rate?.flat_rate_pin_debit_rate?.default ?? "",
    flat_rate_pin_debit_per_transaction:
      pricingDefaults?.flat_rate?.flat_rate_pin_debit_per_transaction
        ?.default ?? "",
  };
};

const getIcPlusDefaults = (pricingDefaults = {}) => {
  return {
    ic_plus_rate: pricingDefaults?.ic_plus?.ic_plus_rate?.default ?? "",
    ic_plus_transaction_fee:
      pricingDefaults?.ic_plus?.ic_plus_transaction_fee?.default ?? "",
    ic_plus_amex_rate:
      pricingDefaults?.ic_plus?.ic_plus_amex_rate?.default ?? "",
    ic_plus_amex_transaction_fee:
      pricingDefaults?.ic_plus?.ic_plus_amex_transaction_fee?.default ?? "",
    ic_plus_pin_debit_network_fee: "yes",
    ic_plus_pin_debit_rate:
      pricingDefaults?.ic_plus?.ic_plus_pin_debit_rate?.default ?? "",
    ic_plus_pin_debit_per_transaction:
      pricingDefaults?.ic_plus?.ic_plus_pin_debit_per_transaction?.default ??
      "",
    ic_plus_amex_toggle: "yes",
  };
};

const getTieredDefaults = (pricingDefaults = {}) => {
  return {
    tiered_qual_rate: pricingDefaults?.tiered?.tiered_qual_rate?.default ?? "",
    tiered_qual_transaction:
      pricingDefaults?.tiered?.tiered_qual_transaction?.default ?? "",
    tiered_qual_debit_rate:
      pricingDefaults?.tiered?.tiered_qual_debit_rate?.default ?? "",
    tiered_qual_debit_per_transaction:
      pricingDefaults?.tiered?.tiered_qual_debit_per_transaction?.default ?? "",
    tiered_mid_qual_rate:
      pricingDefaults?.tiered?.tiered_mid_qual_rate?.default ?? "",
    tiered_mid_qual_transaction:
      pricingDefaults?.tiered?.tiered_mid_qual_transaction?.default ?? "",
    tiered_mid_qual_debit_rate:
      pricingDefaults?.tiered?.tiered_mid_qual_debit_rate?.default ?? "",
    tiered_mid_qual_debit_per_transaction:
      pricingDefaults?.tiered?.tiered_mid_qual_debit_per_transaction?.default ??
      "",
    tiered_non_qual_rate:
      pricingDefaults?.tiered?.tiered_non_qual_rate?.default ?? "",
    tiered_non_qual_transaction:
      pricingDefaults?.tiered?.tiered_non_qual_transaction?.default ?? "",
    tiered_non_qual_debit_rate:
      pricingDefaults?.tiered?.tiered_non_qual_debit_rate?.default ?? "",
    tiered_non_qual_debit_per_transaction:
      pricingDefaults?.tiered?.tiered_non_qual_debit_per_transaction?.default ??
      "",
    tiered_pin_debit_network_fee: "yes",
    tiered_pin_debit_rate:
      pricingDefaults?.tiered?.tiered_pin_debit_rate?.default ?? "",
    tiered_pin_debit_per_transaction:
      pricingDefaults?.tiered?.tiered_pin_debit_per_transaction?.default ?? "",
    tiered_amex_structure: "tiered",
    amex_tier_one_rate:
      pricingDefaults?.tiered?.amex_tier_one_rate?.default ?? "",
    amex_tier_one_fee:
      pricingDefaults?.tiered?.amex_tier_one_fee?.default ?? "",
    amex_tier_two_rate:
      pricingDefaults?.tiered?.amex_tier_two_rate?.default ?? "",
    amex_tier_two_fee:
      pricingDefaults?.tiered?.amex_tier_two_fee?.default ?? "",
    amex_tier_three_rate:
      pricingDefaults?.tiered?.amex_tier_three_rate?.default ?? "",
    amex_tier_three_fee:
      pricingDefaults?.tiered?.amex_tier_three_fee?.default ?? "",
    amex_tier_four_rate:
      pricingDefaults?.tiered?.amex_tier_four_rate?.default ?? "",
    amex_tier_four_fee:
      pricingDefaults?.tiered?.amex_tier_four_fee?.default ?? "",
    tiered_amex_flat_rate:
      pricingDefaults?.tiered?.tiered_amex_flat_rate?.default ?? "",
    tiered_amex_flat_transaction:
      pricingDefaults?.tiered?.tiered_amex_flat_transaction?.default ?? "",
    tiered_amex_ic_plus_rate:
      pricingDefaults?.tiered?.tiered_amex_ic_plus_rate?.default ?? "",
    tiered_amex_ic_plus_transaction:
      pricingDefaults?.tiered?.tiered_amex_ic_plus_transaction?.default ?? "",
    tiered_amex_toggle: "yes",
  };
};

const getACHDefaults = (pricingDefaults = {}) => {
  return {
    ach_discount_rate: pricingDefaults?.ach?.ach_discount_rate?.default ?? "",
    ach_transaction_fee_per_item:
      pricingDefaults?.ach?.ach_transaction_fee_per_item?.default ?? "",
    ach_statement_fee: pricingDefaults?.ach?.ach_statement_fee?.default ?? "",
    ach_monthly_minimum:
      pricingDefaults?.ach?.ach_monthly_minimum?.default ?? "",
    ach_return_fee: pricingDefaults?.ach?.ach_return_fee?.default ?? "",
    ach_noc_fee: pricingDefaults?.ach?.ach_noc_fee?.default ?? "",
    ach_unauthorized_return_fee:
      pricingDefaults?.ach?.ach_unauthorized_return_fee?.default ?? "",
    ach_same_day_fee: pricingDefaults?.ach?.ach_same_day_fee?.default ?? "",
    ach_bank_validation_fee:
      pricingDefaults?.ach?.ach_bank_validation_fee?.default ?? "",
    ach_by_web: "yes",
    ach_by_phone: "no",
    ach_by_preauth: "no",
    ach_credit_transaction: "no",
  };
};

const getKurvPricingDefaults = (pricingDefaults = {}) => {
  return {
    kurv_pricing_swiped_rate:
      pricingDefaults?.kurv_pricing?.kurv_pricing_swiped_rate?.default ?? "",
    kurv_pricing_swiped_txn_fee:
      pricingDefaults?.kurv_pricing?.kurv_pricing_swiped_txn_fee?.default ?? "",
    kurv_pricing_keyed_rate:
      pricingDefaults?.kurv_pricing?.kurv_pricing_keyed_rate?.default ?? "",
    kurv_pricing_keyed_txn_fee:
      pricingDefaults?.kurv_pricing?.kurv_pricing_keyed_txn_fee?.default ?? "",
    kurv_pricing_amex_toggle: "yes",
    kurv_pricing_amex_rate:
      pricingDefaults?.kurv_pricing?.kurv_pricing_amex_rate?.default ?? "",
    kurv_pricing_amex_txn_fee:
      pricingDefaults?.kurv_pricing?.kurv_pricing_amex_txn_fee?.default ?? "",
    kurv_pricing_pin_debit_network_fee: "yes",
    kurv_pricing_pin_debit_rate:
      pricingDefaults?.kurv_pricing?.kurv_pricing_pin_debit_rate?.default ?? "",
    kurv_pricing_pin_debit_per_transaction:
      pricingDefaults?.kurv_pricing?.kurv_pricing_pin_debit_per_transaction
        ?.default ?? "",
  };
};

export const getAllDefaultPricingModelValues = (pricingDefaults = {}) => {
  return {
    ...getDualPricingDefaults(pricingDefaults),
    ...getSurchargeDefaults(pricingDefaults),
    ...getFlatRateDefaults(pricingDefaults),
    ...getIcPlusDefaults(pricingDefaults),
    ...getTieredDefaults(pricingDefaults),
    ...getKurvPricingDefaults(pricingDefaults),
  };
};

export const getDefaultPricingModelValuesExceptActive = (
  activePricingModel,
  pricingDefaults = {},
) => {
  const defaults = {};

  if (activePricingModel !== "dual_pricing") {
    Object.assign(defaults, getDualPricingDefaults(pricingDefaults));
  }

  if (activePricingModel !== "surcharge") {
    Object.assign(defaults, getSurchargeDefaults(pricingDefaults));
  }

  if (activePricingModel !== "flat_rate") {
    Object.assign(defaults, getFlatRateDefaults(pricingDefaults));
  }

  if (activePricingModel !== "ic_plus") {
    Object.assign(defaults, getIcPlusDefaults(pricingDefaults));
  }

  if (activePricingModel !== "tiered") {
    Object.assign(defaults, getTieredDefaults(pricingDefaults));
  }

  return defaults;
};

export const getAllDefaultACHValues = (pricingDefaults = {}) => {
  return getACHDefaults(pricingDefaults);
};
